export const enum LocalStorageKey {
  BROWSER_ID = 'browserId', //浏览器id
  DEVELOPER_ID = 'developerId', //开发者id
  EMAIL = 'email' //邮箱
}
